<script setup>
import { defineEmits, defineProps, computed, toRefs, ref } from "vue"
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import axios from "axios";
import { message } from "ant-design-vue";
import BlockService from "@/services/blockService";

const props = defineProps({
  modelValue: {},
	competitionId: {
		type: [String, Number],
		required: true
	}
});

const { modelValue, competitionId } = toRefs(props);

const emit = defineEmits(['update:modelValue']);
const isDataUpdating = ref(false);
const entity = ref('competition');
const uploadPath = ref('/competition/upload_competition_image');


const setImage = async (e) => {
  const file = e.target.files[0]
  if (!file.type.includes("image/")) {
    alert("Загрузить можно только изображение")
    return
  }
  if (file.size > 1572864) {
    alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.")
    return
  }

  const formData = new FormData()
  formData.append('file', file)

  try {
    isDataUpdating.value = true
    const response = await axios.post(uploadPath.value, formData)
    value.value = response.data;
    modelValue.value.data.entity = entity.value
	  
    // competition.value.competitionData.catalog_image = response.data
    // await saveData()
  } catch (error) {
    console.error('Ошибка при загрузке изображения:', error)
    alert('Произошла ошибка при загрузке изображения')
  } finally {
    isDataUpdating.value = false
  }
}
const deleteImage = async () => {
  isDataUpdating.value = true;
	
	await BlockService.deleteImage(value, competitionId.value)
  value.value = '';
  isDataUpdating.value = false;
};


function get_uploaded_image_asset(path) {
  return ImageService.getCompetitionImagePath(path);
}

const value = computed({
  get: () => props.modelValue?.data?.value,
  set: (newValue) => emit('update:modelValue', {
    ...props.modelValue,
    data: { ...props.modelValue.data, value: newValue }
  })
})
</script>

<template>
  <div>
    <div class="field">
      <label for="catalog_image">Загрузите изображение</label>
      <i class="fas fa-download"></i>
      <input
          :disabled="isDataUpdating"
          type="file"
          accept="image/*"
          id="catalog_image"
          name="catalog_image"
          @change="setImage"
      >
      <div id="catalogFileList"></div>
    </div>

    <div class="field" v-if="value">
      <ImageRender
          :src="get_uploaded_image_asset('competition/' + value)"
          class-name="catalog_image"
          :id="'catalog_image_preview'"
      ></ImageRender>
      <p><a @click.prevent="deleteImage">Удалить</a></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>